module.exports = __webpack_public_path__ + "static/img/3.4e60efa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-es/3.jpg
// module id = fcHW
// module chunks = 1